import React from 'react';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import BackpledgePrompt from './backpledge-prompt';
import { ContributePageConsumer } from '../context';

const GET_CAMPAIGN = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            metricName {
                singular
                plural
            }
            eventName {
                singular
                plural
            }
            stats {
                eventFinalizedCount
                performanceActualTotal
            }
            performances {
                isFinal
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        campaignQuery: ({ context, render }) => (
            <Query query={GET_CAMPAIGN} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
    },
    ({ context, campaignQuery }) => ({
        error: campaignQuery.error,
        loading: campaignQuery.loading,
        campaign: get(campaignQuery, 'data.campaign'),
        contribution: context.contribution,
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

export default props => (
    <Wrapper>
        {({ error, loading, campaign, contribution }) => {
            if (error) throw error;
            if (loading) return null;

            const result = get(campaign, 'stats.performanceActualTotal', 0);

            // Get finalized event count from performances.length instead of
            // eventFinalCount for old campaigns that don't have proper stats
            const eventCount = campaign.performances.filter(x => x.isFinal).length;

            return (
                <BackpledgePrompt
                    eventCount={eventCount}
                    eventNameSingular={campaign.eventName.singular}
                    eventNamePlural={campaign.eventName.plural}
                    result={result}
                    metricNameSingular={campaign.metricName.singular}
                    metricNamePlural={campaign.metricName.plural}
                    amount={result * contribution.amount}
                    {...props}
                />
            );
        }}
    </Wrapper>
);
